const XRP = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <path
      d="M5.42458 15.7325C4.83986 15.7325 4.27497 15.7325 3.63339 15.7325C4.07286 15.2755 4.46939 14.8633 4.86563 14.4509C5.76688 13.5128 6.6558 12.5625 7.57205 11.6392C8.87311 10.3283 10.9237 10.2683 12.3271 11.4785C12.4429 11.5783 12.5523 11.6862 12.6581 11.7966C13.8982 13.0898 15.137 14.3841 16.4143 15.718C15.7946 15.718 15.2239 15.718 14.8097 15.718C14.1038 15.0666 13.4601 14.4913 12.8387 13.8928C12.4061 13.476 12.0174 13.0137 11.5857 12.5958C10.6746 11.7139 9.26964 11.7557 8.37686 12.6794C7.45761 13.6305 6.54312 14.5863 5.62588 15.5393C5.55828 15.6096 5.48519 15.6746 5.42458 15.7325ZM3.89371 4.80428C5.08001 6.04452 6.26685 7.28424 7.45349 8.52413C8.90151 10.0371 11.1915 10.0157 12.6473 8.48413C13.7468 7.32754 14.857 6.18125 15.9613 5.02927C16.0841 4.90114 16.1993 4.76574 16.3581 4.58917C15.6957 4.58917 15.1091 4.58917 14.7404 4.58917C14.1165 5.15489 13.6008 5.59708 13.1151 6.07011C12.63 6.54262 12.1794 7.05042 11.7058 7.53497C10.7026 8.56114 9.29499 8.53875 8.31273 7.50148C7.38866 6.52568 6.4509 5.56286 5.51562 4.59066C4.93424 4.59066 4.35575 4.59066 3.70701 4.59066C3.79735 4.69437 3.84324 4.75151 3.89371 4.80428Z"
      fill="black"
    />
  </svg>
);
export default XRP;
